import { FileText } from "lucide-react";
import Modal from "../../Modal/Modal";
import "../../IFRS/WordProcessorModal.css";

/**
 * Read-only twin of the student's word processor: the same draggable,
 * resizable window and the same document canvas, so a question or an answer
 * looks here exactly as it looked to the student who wrote it. The editing
 * toolbar is dropped — a marker has nothing to type.
 *
 * The document styling (headings, lists, tables) comes from
 * WordProcessorModal.css via `.word-processor-editor`, which is why that
 * stylesheet is imported rather than the rules being restated here.
 *
 * Requires a `ModalProvider` above it, like the exam pages have.
 */
const WordViewerModal = ({
  html,
  eyebrow,
  label,
  isOpen,
  onClose,
}: {
  html: string;
  eyebrow: string;
  label: string;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const header = (
    <div className="flex items-center gap-2">
      <FileText size={18} />
      <span>
        {eyebrow} — {label}
      </span>
    </div>
  );

  return (
    <Modal
      header={header}
      isOpen={isOpen}
      closeModal={onClose}
      resizable
      minWidth="720px"
    >
      {/* The window sizes itself to its content, so a long answer would open
          the width of the screen. Fixing the canvas to a page-like size keeps
          it readable and still resizable by the marker. */}
      <div
        className="word-processor-container"
        style={{ width: "min(820px, 90vw)", height: "min(700px, 78vh)", minHeight: 0 }}
      >
        {/* Tailwind's preflight strips list markers globally; the exam
            stylesheet only sets indentation, so they are restored here. */}
        <div
          className="word-processor-editor [&_ul]:list-disc [&_ol]:list-decimal [&_li]:list-[inherit]"
          dangerouslySetInnerHTML={{ __html: html || "" }}
        />
      </div>
    </Modal>
  );
};

export default WordViewerModal;
